/**
 * CoSingery — **登入「已寄出」面板**（`decisions/044`）
 *
 * 為何抽元件：登入頁要守住硬規則 B（逐檔 ≤200 行）；而「寄出之後顯示咩」係自成一體嘅一段
 *   （已寄出／Plan B 連結／本機 devLink）。
 *
 * ⚠️ 一律**照實**：`emailSent:false` 就一定唔可以扮「寄咗」。
 */
import { useTranslation } from 'react-i18next';

export default function LoginSentPanel({
  email,
  devLink,
  directLink,
}: {
  email: string;
  devLink?: string | undefined;
  /** ⭐ Plan B（`INVITE_DIRECT_LINK=true`）：用邀請碼換到嘅登入連結 */
  directLink?: string | undefined;
}) {
  const { t } = useTranslation();
  return (
    <div data-testid="login-sent" style={{ display: 'grid', gap: '6px' }}>
      {directLink ? (
        <>
          <p style={{ margin: 0 }}>{t('login_direct_link_notice')}</p>
          <p style={{ margin: 0 }} data-testid="login-direct-link">
            <a href={directLink} style={{ color: 'var(--color-accent)', wordBreak: 'break-all' }}>
              {directLink}
            </a>
          </p>
        </>
      ) : (
        <>
          <p style={{ margin: 0 }}>{t('login_sent_notice', { email })}</p>
          <p className="footnote" style={{ margin: 0 }}>
            {t('login_sent_hint')}
          </p>
        </>
      )}
      {devLink ? (
        <p className="footnote" style={{ margin: 0 }} data-testid="login-devlink">
          {t('login_devlink_label')}{' '}
          <a href={devLink} style={{ color: 'var(--color-accent)' }}>
            {devLink}
          </a>
        </p>
      ) : null}
    </div>
  );
}
